import {useCallback, useEffect, useRef, useState} from "react";
import {getDirectoryEntriesByRole, getUsers, mapDirectoryEntriesById} from "../../service/UserService";
import {sortSchedulerWorkersByUserId} from './schedulerWorkerOrder';

export default function useSchedulerResources() {
    const [fieldWorkerArray, setFieldWorkerArray] = useState([]);
    const [fieldWorkerMap, setFieldWorkerMap] = useState({});
    const [fieldSupervisorMap, setFieldSupervisorMap] = useState({});
    const [businessDate, setBusinessDate] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const isMountedRef = useRef(true);
    const requestSequenceRef = useRef(0);

    const refreshUsers = useCallback(async () => {
        const requestSequence = requestSequenceRef.current + 1;
        requestSequenceRef.current = requestSequence;
        if (isMountedRef.current) setIsLoading(true);
        try {
            const response = await getUsers({
                roles: ['WORKER', 'SUPERVISOR'],
                include: ['location_tracking'],
            });
            if (!response.ok) {
                const responseText = await response.text();
                throw new Error(responseText || "Unable to load worker directory.");
            }

            const payload = await response.json();
            if (!isMountedRef.current || requestSequence !== requestSequenceRef.current) {
                return false;
            }
            const workers = sortSchedulerWorkersByUserId(getDirectoryEntriesByRole(payload, 'WORKER'));
            const supervisors = getDirectoryEntriesByRole(payload, 'SUPERVISOR');
            setFieldWorkerArray(workers);
            setFieldWorkerMap(mapDirectoryEntriesById(workers));
            setFieldSupervisorMap(mapDirectoryEntriesById(supervisors));
            setBusinessDate(payload.business_date || "");
            setErrorMessage("");
            return true;
        } catch (error) {
            console.log("error", error);
            if (isMountedRef.current && requestSequence === requestSequenceRef.current) {
                setErrorMessage(error.message || "Unable to load worker directory.");
            }
            return false;
        } finally {
            if (isMountedRef.current && requestSequence === requestSequenceRef.current) {
                setIsLoading(false);
            }
        }
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        refreshUsers();
        return () => {
            isMountedRef.current = false;
            requestSequenceRef.current += 1;
        };
    }, [refreshUsers]);

    return {
        businessDate,
        errorMessage,
        fieldWorkerArray,
        fieldWorkerMap,
        fieldSupervisorMap,
        isLoading,
        refreshUsers,
    };
}
